import { qrMatrix, qrPath } from '../lib/qr.ts';

export type Credential = { memberId: string; displayName: string; pin: string; qrToken: string };

function Qr({ text, label }: { text: string; label: string }) {
  const matrix = qrMatrix(text);
  const size = matrix.length + 8;
  return (
    <svg class="qr-code" viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shape-rendering="crispEdges">
      <rect width={size} height={size} fill="#fff" />
      <path d={qrPath(matrix)} fill="#000" />
    </svg>
  );
}

/** Tarjetas imprimibles: QR que abre la votación directo, y el PIN como alternativa. */
export function CredentialCards({ credentials, eventTitle, onClose }: { credentials: Credential[]; eventTitle: string; onClose: () => void }) {
  const base = `${location.origin}/legislador`;
  return (
    <section class="panel credentials" aria-label="Credenciales">
      <div class="row no-print">
        <h2 style={{ marginRight: 'auto' }}>Credenciales de esta sesión</h2>
        <button class="btn primary" onClick={() => print()}>Imprimir tarjetas</button>
        <button class="btn" onClick={onClose}>Ocultar</button>
      </div>
      <p class="hint no-print">Se muestran solo ahora: si las cierras sin imprimir, emítelas de nuevo (las anteriores dejan de servir).</p>
      <div class="cards">
        {credentials.map((c) => (
          <article class="card" key={c.memberId}>
            <h3>{c.displayName}</h3>
            <p class="hint">{eventTitle}</p>
            <Qr text={`${base}?qr=${c.qrToken}`} label={`Código QR de ${c.displayName}`} />
            <p>PIN <b class="pinval">{c.pin}</b></p>
            <p class="hint">Escanea el código con la cámara del teléfono, o entra a {base} y escribe el PIN. No la compartas.</p>
          </article>
        ))}
      </div>
    </section>
  );
}
